module.exports = __webpack_public_path__ + "static/weeks123_1-854451173f945adca963a7044641692d.jpg";